import { emailSchema } from 'utils/schema';
import * as yup from 'yup';
import { TRegistrationFormValues } from './RegistrationForm.types';

export const registrationSchema = yup.object<TRegistrationFormValues>().shape({
  email: emailSchema.required('Email is required'),
  password: yup
    .string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters')
    .test('has-number', 'Password must contain at least 1 number', (value) => {
      return value ? /\d/.test(value) : false;
    })
    .test(
      'has-capital',
      'Password must contain at least 1 capital letter',
      (value) => {
        return value ? /[A-Z]/.test(value) : false;
      }
    )
    .test(
      'has-symbol',
      'Password must contain at least 1 special character',
      (value) => {
        return value
          ? /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value)
          : false;
      }
    ),
});
